<template>
  <div>
    <PageCaption
      pageCaptionTitle="ATM Screen"
      pageCaptionDescription="Informe os dados para Campanha"
    />
    <CampaignFormatSlotsSection :propSlotType="EnumATMScreenFormatSlotTypes.A1" propSlotLabel="Abertura *" />

    <c-q-separator class="q-pt-lg q-pb-lg" />
    
    <CampaignFormatSlotsSection :propSlotType="EnumATMScreenFormatSlotTypes.A2" propSlotLabel="PropagIF *" />
    
    <c-q-separator class="q-pt-lg q-pb-lg" />
    
    <CampaignFormatSlotsSection :propSlotType="EnumATMScreenFormatSlotTypes.A3" propSlotLabel="Retire o seu Dinheiro *" />
    
    <c-q-separator class="q-pt-lg q-pb-lg" />
    
    <CampaignInstitutions class="q-pb-md" />

    <CampaignPCs />


  </div>
</template>

<script setup lang="ts">
import CampaignInstitutions             from '@/components/campaign/CampaignInstitutions.vue';
import CampaignPCs                      from '@/components/campaign/CampaignPCs.vue';
import CampaignFormatSlotsSection       from '@/components/campaign/CampaignFormatSlotsSection.vue';
import PageCaption                      from '@/components/PageCaption.vue';
import { EnumATMScreenFormatSlotTypes } from '@/enums/enums';
</script>

<style scoped>

</style>
